"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lit_html_1 = require("lit-html");
const reduxular_1 = require("reduxular");
const split_js_1 = __importDefault(require("split.js"));
const utilities_1 = require("../../../services/utilities");
const is_company_currently_using_crewCal_1 = require("../../../utilities/company-status-events/is-company-currently-using-crewCal");
const define_custom_element_1 = require("../../../utilities/define-custom-element");
const html_sanitization_1 = require("../../../utilities/html-sanitization");
require("../jo-action-item-notes");
require("../jo-chat/jo-chat-messenger/jo-chat-messenger-jill");
require("../jo-contact/jo-contact");
require("../jo-drop-reveal");
require("./jo-call-screen-custom-fields");
require("./jo-call-screen-end-of-script");
require("./jo-call-screen-pricing");
require("./jo-call-screen-services");
require("./jo-call-screen-title");
require("./jo-call-screen-transfer-instructions");
require("./jo-crew-cal-scheduling/jo-crew-cal-scheduling");
const state_1 = require("./redux/state");
const outbound_queue_item_utils_1 = require("./utilities/outbound-queue-item-utils");
const InitialState = {
    actionItem: state_1.InitialJOCallScreenState.actionItem,
    actionItemId: state_1.InitialJOCallScreenState.actionItemId,
    settingUpInitialCallScreenInfoHasInitiated: state_1.InitialJOCallScreenState.settingUpInitialCallScreenInfoHasInitiated,
    actionItemTitles: state_1.InitialJOCallScreenState.actionItemTitles,
    actionItemQuickNotes: state_1.InitialJOCallScreenState.actionItemQuickNotes,
    authenticatedUser: state_1.InitialJOCallScreenState.authenticatedUser,
    callAnswered: state_1.InitialJOCallScreenState.callAnswered,
    calculatedPrice: state_1.InitialJOCallScreenState.calculatedPrice,
    callEnded: state_1.InitialJOCallScreenState.callEnded,
    callId: state_1.InitialJOCallScreenState.callId,
    callScreenMode: state_1.InitialJOCallScreenState.callScreenMode,
    canInitiateNewTransfer: state_1.InitialJOCallScreenState.canInitiateNewTransfer,
    chatId: 'NOT_SET',
    chatMessengerInput: '',
    chatMessengerQuickNotes: state_1.InitialJOCallScreenState.chatMessengerQuickNotes,
    companyForCollection: state_1.InitialJOCallScreenState.companyForCollection,
    companyForTransferInstructions: state_1.InitialJOCallScreenState.companyForTransferInstructions,
    companyId: state_1.InitialJOCallScreenState.companyId,
    contact: state_1.InitialJOCallScreenState.contact,
    customFieldResponsesInputValues: state_1.InitialJOCallScreenState.customFieldResponsesInputValues,
    contactInputValues: state_1.InitialJOCallScreenState.contactInputValues,
    currentDropRevealIndex: 1,
    direction: state_1.InitialJOCallScreenState.direction,
    externalTransferPhoneNumberInputValue: state_1.InitialJOCallScreenState.externalTransferPhoneNumberInputValue,
    followupRequestDateInputValue: state_1.InitialJOCallScreenState.followupRequestDateInputValue,
    jillInteractionMode: 'ACTION_ITEM',
    incomingCallType: state_1.InitialJOCallScreenState.incomingCallType,
    incomingTransferCompleted: state_1.InitialJOCallScreenState.incomingTransferCompleted,
    isTransferRecipientJillOnACall: state_1.InitialJOCallScreenState.isTransferRecipientJillOnACall,
    jillCallSid: state_1.InitialJOCallScreenState.jillCallSid,
    jillsToTransferTo: state_1.InitialJOCallScreenState.jillsToTransferTo,
    minimumPriceApplied: state_1.InitialJOCallScreenState.minimumPriceApplied,
    noteText: state_1.InitialJOCallScreenState.noteText,
    outboundAttemptId: state_1.InitialJOCallScreenState.outboundAttemptId,
    previousCustomFieldResponses: state_1.InitialJOCallScreenState.previousCustomFieldResponses,
    previousLineItemResponses: state_1.InitialJOCallScreenState.previousLineItemResponses,
    previousServiceResponses: state_1.InitialJOCallScreenState.previousServiceResponses,
    priceQuote: state_1.InitialJOCallScreenState.priceQuote,
    pricingInputValues: state_1.InitialJOCallScreenState.pricingInputValues,
    quickTitlesForActionItem: state_1.InitialJOCallScreenState.quickTitlesForActionItem,
    redirectingIncomingCallbackToOutgoing: state_1.InitialJOCallScreenState.redirectingIncomingCallbackToOutgoing,
    selectedJillForTransfer: state_1.InitialJOCallScreenState.selectedJillForTransfer,
    selectedServices: state_1.InitialJOCallScreenState.selectedServices,
    selectedServicesWithCalculatedPrice: state_1.InitialJOCallScreenState.selectedServicesWithCalculatedPrice,
    saveActionItemInitiated: state_1.InitialJOCallScreenState.saveActionItemInitiated,
    serviceAreaDescription: state_1.InitialJOCallScreenState.serviceAreaDescription,
    serviceLineItemResponses: state_1.InitialJOCallScreenState.serviceLineItemResponses,
    showTransferInitiatedBox: state_1.InitialJOCallScreenState.showTransferInitiatedBox,
    transferCallSid: state_1.InitialJOCallScreenState.transferCallSid,
    transferCallStatus: state_1.InitialJOCallScreenState.transferCallStatus,
    transferId: state_1.InitialJOCallScreenState.transferId,
    transferRecipientName: state_1.InitialJOCallScreenState.transferRecipientName,
    transferState: state_1.InitialJOCallScreenState.transferState,
    transferTo: state_1.InitialJOCallScreenState.transferTo,
    userCallSid: state_1.InitialJOCallScreenState.userCallSid,
    userCallStatus: state_1.InitialJOCallScreenState.userCallStatus,
};
class JOCallScreenCollection extends HTMLElement {
    constructor() {
        super(...arguments);
        this.store = (0, reduxular_1.createObjectStore)(InitialState, (state) => (0, lit_html_1.render)(this.render(state), this), this, utilities_1.setPropsReducer);
    }
    set props(props) {
        if ((0, utilities_1.deepLeftCheck)(props, this.store.getState()) === true) {
            return;
        }
        this.store.dispatch({
            type: 'SET_PROPS',
            props,
        });
    }
    async connectedCallback() {
        this.createSplitBarDivider();
    }
    createSplitBarDivider() {
        const dropRevealsContainer = this.querySelector('#drop-reveals-container');
        const notesContainer = this.querySelector('#notes-container');
        if (!dropRevealsContainer || !notesContainer) {
            return;
        }
        this.createDivindingSplits(dropRevealsContainer, notesContainer);
    }
    createDivindingSplits(dropRevealsContainer, notesContainer) {
        (0, split_js_1.default)([
            dropRevealsContainer,
            notesContainer,
        ], {
            gutterSize: 12,
            sizes: [
                50,
                50,
            ],
            direction: 'vertical',
            minSize: 0,
        });
    }
    async sendToCompany() {
        (0, utilities_1.raiseCustomEvent)(this, 'actionitemsendtocompany', {
            actionItemStatusTypeName: 'Assigned to Company',
        });
    }
    async sendToCallbacks() {
        (0, utilities_1.raiseCustomEvent)(this, 'actionitemsendtocallbacks', {
            actionItemStatusTypeName: 'Callback',
        });
    }
    async save() {
        (0, utilities_1.raiseCustomEvent)(this, 'actionitemsave', {
            actionItemStatusTypeName: 'NOT_SET',
        });
    }
    dropRevealContinued(index) {
        this.store.currentDropRevealIndex = index + 1;
    }
    shouldSaveButtonDisappear() {
        if (this.store.callScreenMode === 'ACTION_ITEM') {
            return this.store.actionItemId === 'NOT_SET';
        }
        return true;
    }
    shouldHideTransferInstructions(state) {
        if (state.companyForTransferInstructions === 'NOT_SET') {
            return true;
        }
        const usersWhoCanReceiveTransfers = state.companyForTransferInstructions.users.filter(user => user.can_receive_call_transfer);
        return usersWhoCanReceiveTransfers.length === 0;
    }
    shouldHideServices(state) {
        if (state.companyForCollection !== 'NOT_SET') {
            return (state.companyForCollection.services.length === 0 &&
                state.companyForCollection.services_not_provided.length === 0);
        }
        return true;
    }
    getNextDropRevealIndexBasedOnServices(state) {
        if (state.selectedServices.length === 0) {
            return 4; //closing script
        }
        if (this.shouldHideCustomQuestions(state)) {
            return 3; //pricing section
        }
        return 2; //custom questions
    }
    shouldHideCustomQuestions(state) {
        if (state.selectedServices.length === 0) {
            return true;
        }
        if (state.selectedServices.every(selectedService => selectedService.custom_fields.length === 0)) {
            return true;
        }
        const atLeastOneCustomFieldShouldAppear = state.selectedServices.some(service => service.custom_fields.some(customField => customField.call_screen_appear === true));
        if (atLeastOneCustomFieldShouldAppear) {
            return false;
        }
        return true;
    }
    shouldHidePricing(state) {
        return state.selectedServices.length === 0;
    }
    shouldHideAlerts(state) {
        if (state.companyForCollection !== 'NOT_SET') {
            return (new Date().getTime() >
                new Date(state.companyForCollection.alerts_expiration_date).getTime());
        }
    }
    shouldHideCrewCalContainer(company) {
        if (this.store.selectedServices.length === 0) {
            return true;
        }
        const companyStatusEvents = company === 'NOT_SET' ? [] : company.status_events;
        if ((0, is_company_currently_using_crewCal_1.isCompanyCurrentlyUsingCrewCal)(companyStatusEvents) === true) {
            return false;
        }
        return true;
    }
    getServicesImportantNotes(state) {
        return state.companyForCollection === 'NOT_SET'
            ? ''
            : (0, html_sanitization_1.renderHTMLStringSafely)(state.companyForCollection.call_screen_section_notes[0]?.services_notes || '');
    }
    shouldHideServicesNotes(state) {
        return (state.companyForCollection === 'NOT_SET' ||
            state.companyForCollection.call_screen_section_notes.length === 0 ||
            state.companyForCollection.call_screen_section_notes[0]?.services_notes?.length === 0);
    }
    getTransferImportantNotes(state) {
        return state.companyForCollection === 'NOT_SET'
            ? ''
            : (0, html_sanitization_1.renderHTMLStringSafely)(state.companyForCollection.call_screen_section_notes[0]?.transfer_notes || '');
    }
    shouldHideTransferNotes(state) {
        return (state.companyForCollection === 'NOT_SET' ||
            state.companyForCollection.call_screen_section_notes.length === 0 ||
            state.companyForCollection.call_screen_section_notes[0]?.transfer_notes?.length === 0);
    }
    getPricingImportantNotes(state) {
        return state.companyForCollection === 'NOT_SET'
            ? ''
            : (0, html_sanitization_1.renderHTMLStringSafely)(state.companyForCollection.call_screen_section_notes[0]?.pricing_notes || '');
    }
    shouldHidePricingNotes(state) {
        return (state.companyForCollection === 'NOT_SET' ||
            state.companyForCollection.call_screen_section_notes.length === 0 ||
            state.companyForCollection.call_screen_section_notes[0]?.pricing_notes?.length === 0);
    }
    getCustomQuestionImportantNotes(state) {
        return state.companyForCollection === 'NOT_SET'
            ? ''
            : (0, html_sanitization_1.renderHTMLStringSafely)(state.companyForCollection.call_screen_section_notes[0]?.custom_questions_notes ||
                '');
    }
    shouldHideCustomQuestionNotes(state) {
        return (state.companyForCollection === 'NOT_SET' ||
            state.companyForCollection.call_screen_section_notes.length === 0 ||
            state.companyForCollection.call_screen_section_notes[0]?.custom_questions_notes
                ?.length === 0);
    }
    noCustomCallScreenInformationAddedForCompany(state) {
        return (this.shouldHideServices(state) &&
            this.shouldHideServicesNotes(state) &&
            this.shouldHideTransferInstructions(state) &&
            this.shouldHideCustomQuestions(state));
    }
    closeOutboundQueueItemClicked() {
        (0, utilities_1.assertIsSet)(this.store.outboundAttemptId);
        (0, outbound_queue_item_utils_1.closeOutboundQueueItem)(this.store.outboundAttemptId);
        (0, utilities_1.raiseCustomEvent)(this, 'saveActionItemButtonClicked');
        this.sendToCompany();
    }
    render(state) {
        return (0, lit_html_1.html) `
            <link rel="stylesheet" href="/styles/jo-styles.css" />
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
            <style>
                .jo-call-screen-collection--main-container {
                    height: 100%;
                    width: 100%;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    padding: 0.5rem 0.5rem;
                    padding-bottom: 0;
                }

                .jo-call-screen-collection--drop-reveals-container {
                    height: 70%;
                    width: 100%;
                    overflow-y: auto;
                }

                .jo-call-screen-collection--drop-reveal-container {
                    box-sizing: border-box;
                    padding: 0.5vmin;
                }

                .jo-call-screen-collection--notes-and-buttons-container {
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                    padding-top: 0.5rem;
                    padding-left: 0.2rem;
                    height: 30%;
                    width: 100%;
                }

                .jo-call-screen-collection--chat-menu-container {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    justify-content: center;
                    background-color: white;
                    border: solid 1px #979797;
                    border-radius: 4px;
                    box-sizing: border-box;
                }

                .jo-call-screen-collection--chat-menu-button {
                    color: var(--jo-text-default);
                    flex: 1;
                    text-align: center;
                    padding: 0.1rem;
                    border: none;
                    font-weight: bold;
                    font-size: calc(7px + 1vmin);
                    box-shadow: var(--jo-card-shadow-1);
                    background-color: var(--jo-accent-background-light);
                    cursor: pointer;
                }

                .jo-call-screen-collection--chat-menu-button:focus {
                    background-color: var(--jo-text-default);
                    color: white;
                }

                .jo-call-screen-collection--flex-ChatMode {
                    flex: 3;
                }

                .jo-call-screen-collection--flex-RegMode {
                    flex: 1.2;
                }

                .jo-call-screen-collection--final-buttons-container {
                    display: flex;
                    align-items: flex-end;
                }

                .jo-call-screen-collection--send-to-company-button-container {
                    padding-top: 0.5rem;
                }

                .jo-call-screen-collection--send-to-callbacks-button-container {
                    padding-top: 0.5rem;
                    padding-left: 1rem;
                }

                .jo-call-screen-collection--notes-container {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    overflow-y: auto;
                    border-top: solid 1px var(--jo-accent-background-dark);
                    padding-top: 0.5rem;
                }

                .jo-call-screen-collection--action-item-notes-container {
                    background-color: var(--jo-accent-background-light);
                    padding: 0.2rem 0.3rem;
                    flex: 80%;
                }

                .jo-call-screen-collection--title-and-request-container {
                    display: flex;
                    flex: 20%;
                    justify-content: space-around;
                    align-items: flex-start;
                    padding: 0.2rem 1rem;
                }

                .jo-call-screen-collection--request-follow-up {
                    display: flex;
                    flex: 30%;
                    justify-content: space-between;
                    flex-direction: column;
                }

                .jo-call-screen-collection--jo-call-screen-title-container {
                    flex: 70%;
                }

                .jo-call-screen-collection--request-follow-up-input {
                    height: 23px;
                }
                .alerts {
                    border: 5px solid var(--jo-danger);
                    color: var(--jo-danger);
                    background-color: var(--jo-danger-light);
                    box-sizing: border-box;
                    padding: calc(5px + 1vmin);
                    border-radius: var(--jo-wide-border-radius-1);
                    animation: wiggleAnimation 1s;
                    animation-iteration-count: 7;
                }
                .important-notes {
                    margin-bottom: 2rem;
                    background-color: var(--jo-primary-light) !important;
                    color: var(--jo-text-default);
                }

                .jo-call-screen-collection--no-custom-information-added-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    font-size: 1.25rem;
                }

                .jo-call-screen-collection--chat-messenger-container {
                    height: 100%;
                    width: 100%;
                    box-sizing: border-box;
                }

                @keyframes wiggleAnimation {
                    0% {
                        transform: rotate(0deg);
                    }
                    25% {
                        transform: rotate(0.5deg) scale(0.99);
                    }
                    50% {
                        transform: rotate(0deg);
                    }
                    75% {
                        transform: rotate(-0.5deg) scale(0.99);
                    }
                    100% {
                        transform: rotate(0deg);
                    }
                }
            </style>

            <div class="jo-call-screen-collection--main-container">
                <div
                    id="drop-reveals-container"
                    class="jo-call-screen-collection--drop-reveals-container"
                >
                    <div class="alerts" ?hidden=${this.shouldHideAlerts(state)}>
                        ${getAlert(state)}
                    </div>

                    ${this.noCustomCallScreenInformationAddedForCompany(state)
            ? (0, lit_html_1.html) `
                              <section
                                  class="
                                jo-global--emptyIconContainer
                                jo-call-screen-collection--no-custom-information-added-container
                            "
                              >
                                  <div>
                                      <span class="material-icons" style="font-size: 5rem;">
                                          support_agent
                                      </span>
                                      <div>
                                          No Services, Custom Questions, or Transfer Instructions
                                          Added
                                      </div>
                                  </div>
                              </section>
                          `
            : ''}

                    <div
                        class="jo-call-screen-collection--drop-reveal-container"
                        ?hidden=${this.shouldHideServices(state)}
                    >
                        <jo-drop-reveal
                            .titleText=${'Services'}
                            .open=${state.currentDropRevealIndex === 1}
                            @opened=${() => (this.store.currentDropRevealIndex = 1)}
                            .child=${(0, lit_html_1.html) `
                                <div
                                    class="jo-global--card important-notes"
                                    ?hidden=${this.shouldHideServicesNotes(state)}
                                >
                                    ${this.getServicesImportantNotes(state)}
                                </div>
                                <jo-call-screen-services
                                    .props=${{
            selectedServices: getSortedServices(state.selectedServices),
            services: state.companyForCollection === 'NOT_SET'
                ? []
                : getSortedServices(state.companyForCollection.services),
            serviceResponses: state.previousServiceResponses,
            servicesNotProvided: state.companyForCollection === 'NOT_SET'
                ? ''
                : state.companyForCollection.services_not_provided,
        }}
                                    @continued=${() => {
            this.dropRevealContinued(1);
        }}
                                ></jo-call-screen-services>
                            `}
                        ></jo-drop-reveal>
                    </div>

                    <div
                        class="jo-call-screen-collection--drop-reveal-container"
                        ?hidden=${this.shouldHideTransferInstructions(state)}
                    >
                        <jo-drop-reveal
                            .titleText=${'Transfer Instructions'}
                            .open=${state.currentDropRevealIndex === 2}
                            @opened=${() => (this.store.currentDropRevealIndex = 2)}
                            .child=${(0, lit_html_1.html) `
                                <div
                                    class="jo-global--card important-notes"
                                    ?hidden=${this.shouldHideTransferNotes(state)}
                                >
                                    ${this.getTransferImportantNotes(state)}
                                </div>
                                <jo-call-screen-transfer-instructions
                                    .props=${{
            authenticatedUser: state.authenticatedUser,
            callAnswered: state.callAnswered,
            callEnded: state.callEnded,
            callId: state.callId,
            callScreenMode: state.callScreenMode,
            canInitiateNewTransfer: state.canInitiateNewTransfer,
            companyForTransferInstructions: state.companyForTransferInstructions,
            direction: state.direction,
            externalTransferPhoneNumberInputValue: state.externalTransferPhoneNumberInputValue,
            isTransferRecipientJillOnACall: state.isTransferRecipientJillOnACall,
            jillCallSid: state.jillCallSid,
            jillsToTransferTo: state.jillsToTransferTo,
            selectedJillForTransfer: state.selectedJillForTransfer,
            showTransferInitiatedBox: state.showTransferInitiatedBox,
            transferCallSid: state.transferCallSid,
            transferCallStatus: state.transferCallStatus,
            transferId: state.transferId,
            transferRecipientName: state.transferRecipientName,
            transferState: state.transferState,
            transferTo: state.transferTo,
            userCallSid: state.userCallSid,
            userCallStatus: state.userCallStatus,
        }}
                                    @continued=${() => {
            const nextIndex = this.getNextDropRevealIndexBasedOnServices(state);
            this.dropRevealContinued(nextIndex);
        }}
                                ></jo-call-screen-transfer-instructions>
                            `}
                        ></jo-drop-reveal>
                    </div>

                    <div
                        class="jo-call-screen-collection--drop-reveal-container"
                        ?hidden=${this.shouldHideCustomQuestions(state)}
                    >
                        <jo-drop-reveal
                            .titleText=${'Custom Questions'}
                            .open=${state.currentDropRevealIndex === 3}
                            @opened=${() => (this.store.currentDropRevealIndex = 3)}
                            .child=${(0, lit_html_1.html) `
                                <div
                                    class="jo-global--card important-notes"
                                    ?hidden=${this.shouldHideCustomQuestionNotes(state)}
                                >
                                    ${this.getCustomQuestionImportantNotes(state)}
                                </div>
                                <jo-call-screen-custom-fields
                                    .props=${{
            callScreenMode: state.callScreenMode,
            selectedServices: getSortedServices(state.selectedServices),
            customFieldResponses: getCustomFieldResponses(state),
        }}
                                    @continued=${() => this.dropRevealContinued(3)}
                                    @inputvalueschanged=${(e) => {
            e.stopPropagation();
            (0, utilities_1.raiseCustomEvent)(this, 'customfieldresponsesinputvalueschanged', e.detail);
        }}
                                ></jo-call-screen-custom-fields>
                            `}
                        ></jo-drop-reveal>
                    </div>

                    <div
                        class="jo-call-screen-collection--drop-reveal-container"
                        ?hidden=${this.shouldHidePricing(state)}
                    >
                        <jo-drop-reveal
                            .titleText=${'Pricing'}
                            .open=${state.currentDropRevealIndex === 4}
                            @opened=${() => (this.store.currentDropRevealIndex = 4)}
                            .child=${(0, lit_html_1.html) `
                                <div
                                    class="jo-global--card important-notes"
                                    ?hidden=${this.shouldHidePricingNotes(state)}
                                >
                                    ${this.getPricingImportantNotes(state)}
                                </div>
                                <jo-call-screen-pricing
                                    .props=${{
            calculatedPrice: state.calculatedPrice,
            minimumPriceApplied: state.minimumPriceApplied,
            priceQuote: state.priceQuote,
            selectedServices: getSortedServices(state.selectedServices),
            serviceLineItemResponses: getServiceLineItemResponses(state),
        }}
                                    @continued=${() => this.dropRevealContinued(4)}
                                ></jo-call-screen-pricing>
                            `}
                        ></jo-drop-reveal>
                    </div>

                    <div
                        class="jo-call-screen-collection--drop-reveal-container"
                        ?hidden=${this.shouldHideCrewCalContainer(state.companyForCollection)}
                    >
                        <jo-drop-reveal
                            .titleText=${'CREW CAL Scheduling'}
                            .open=${state.currentDropRevealIndex === 5}
                            @opened=${() => (this.store.currentDropRevealIndex = 5)}
                            .child=${(0, lit_html_1.html) `
                                <jo-crew-cal-scheduling
                                    .props=${{
            viewType: 'SCHEDULING',
            companyId: state.companyId,
            companyForCollection: state.companyForCollection,
            contactInputValues: state.contactInputValues,
            companyCalendar: getCompanyCalendar(state.companyForCollection),
            companyCalendarConnections: getCompanyCalendarConnections(state.companyForCollection),
            pricingInputValues: state.pricingInputValues,
            customFieldResponsesInputValues: state.customFieldResponsesInputValues,
            selectedServicesWithCalculatedPrice: state.selectedServicesWithCalculatedPrice,
        }}
                                    @appointmentScheduled=${(e) => (0, utilities_1.raiseCustomEvent)(this, 'appointmentScheduled', e.detail)}
                                    @continued=${() => this.dropRevealContinued(5)}
                                ></jo-crew-cal-scheduling>
                            `}
                        ></jo-drop-reveal>
                    </div>

                    <div
                        class="jo-call-screen-collection--drop-reveal-container"
                        ?hidden=${shouldHideEndOfScript(state)}
                    >
                        <jo-drop-reveal
                            .titleText=${'Closing Script'}
                            .open=${state.currentDropRevealIndex === 6}
                            @opened=${() => (this.store.currentDropRevealIndex = 6)}
                            .child=${(0, lit_html_1.html) `
                                <jo-call-screen-end-of-script
                                    .props=${{
            endOfScriptText: state.companyForCollection === 'NOT_SET'
                ? ''
                : state.companyForCollection.end_of_script_text,
        }}
                                    @continued=${() => this.dropRevealContinued(6)}
                                ></jo-call-screen-end-of-script>
                            `}
                        ></jo-drop-reveal>
                    </div>
                </div>
                <div
                    id="notes-container"
                    class="jo-call-screen-collection--notes-and-buttons-container ${this.getFlexClassForNotesAndChatContainer()}"
                >
                    <div
                        class="jo-call-screen-collection--chat-menu-container"
                        ?hidden=${state.callScreenMode !== 'CHAT'}
                    >
                        <button
                            class="jo-call-screen-collection--chat-menu-button"
                            @click=${() => {
            (0, utilities_1.raiseCustomEvent)(this, 'jillInteractionModeChanged', 'ACTION_ITEM');
            this.store.jillInteractionMode = 'ACTION_ITEM';
        }}
                        >
                            Action Item
                        </button>
                        <button
                            class="jo-call-screen-collection--chat-menu-button"
                            @click=${() => {
            (0, utilities_1.raiseCustomEvent)(this, 'jillInteractionModeChanged', 'CHAT');
            this.store.jillInteractionMode = 'CHAT';
        }}
                        >
                            Chat Messenger
                        </button>
                    </div>

                    <div
                        class="jo-call-screen-collection--chat-messenger-container"
                        ?hidden=${this.store.jillInteractionMode !== 'CHAT'}
                    >
                        <jo-chat-messenger-jill
                            .props=${{
            authenticatedUser: state.authenticatedUser,
            chatMessengerInput: state.chatMessengerInput,
            chatId: state.chatId,
            quickNotes: state.chatMessengerQuickNotes,
            companyId: state.companyId,
        }}
                            @chatMessengerInputChanged=${(e) => {
            (0, utilities_1.raiseCustomEvent)(this, 'chatMessengerInputChanged', e.detail);
        }}
                        ></jo-chat-messenger-jill>
                    </div>

                    <div
                        class="jo-call-screen-collection--notes-container"
                        ?hidden=${this.store.jillInteractionMode !== 'ACTION_ITEM'}
                    >
                        <div class="jo-call-screen-collection--title-and-request-container">
                            <jo-call-screen-title
                                class="jo-call-screen-collection--jo-call-screen-title-container"
                                .props=${{
            title: getActionItemTitle(state),
            subtitle: getActionItemSubtitle(state),
            titles: state.quickTitlesForActionItem,
        }}
                                @continued=${() => this.dropRevealContinued(6)}
                                @actionItemTitleChanged=${(e) => {
            (0, utilities_1.raiseCustomEvent)(this, 'actionItemTitleChanged', e.detail);
        }}
                                @actionItemSubTitleChanged=${(e) => {
            (0, utilities_1.raiseCustomEvent)(this, 'actionItemSubTitleChanged', e.detail);
        }}
                            ></jo-call-screen-title>
                        </div>

                        <div class="jo-call-screen-collection--action-item-notes-container">
                            <jo-action-item-notes
                                .props=${{
            actionItemNotes: state.actionItem === 'NOT_SET'
                ? []
                : state.actionItem.action_item_notes,
            authenticatedUser: state.authenticatedUser,
            displayCopyButton: true,
            quickNotes: state.actionItemQuickNotes,
            noteText: state.noteText,
        }}
                                @notetextchanged=${(e) => {
            (0, utilities_1.raiseCustomEvent)(this, 'notetextchanged', e.detail);
        }}
                                @copyActionItemToClipboard=${() => {
            (0, utilities_1.raiseCustomEvent)(this, 'copyActionItemToClipboard');
        }}
                            ></jo-action-item-notes>
                        </div>
                    </div>

                    <div
                        class="jo-call-screen-collection--final-buttons-container"
                        ?hidden=${this.store.jillInteractionMode !== 'ACTION_ITEM'}
                    >
                        <div class="jo-call-screen-collection--send-to-company-button-container">
                            <jo-button
                                .type=${'ACTION_BUTTON_1'}
                                .text=${'Send to Company'}
                                .disabled=${shouldDisableActionItemButtons(state)}
                                @joButtonClick=${() => {
            (0, utilities_1.raiseCustomEvent)(this, 'saveActionItemButtonClicked');
            this.sendToCompany();
        }}
                            ></jo-button>
                        </div>

                        <div class="jo-call-screen-collection--send-to-callbacks-button-container">
                            <jo-button
                                .type=${'SECONDARY_BUTTON_1'}
                                .text=${'Send to Callbacks'}
                                .disabled=${shouldDisableActionItemButtons(state)}
                                @joButtonClick=${() => {
            (0, utilities_1.raiseCustomEvent)(this, 'saveActionItemButtonClicked');
            this.sendToCallbacks();
        }}
                            ></jo-button>
                        </div>

                        <div
                            ?hidden=${state.outboundAttemptId === 'NOT_SET'}
                            class="jo-call-screen-collection--send-to-callbacks-button-container"
                        >
                            <jo-button
                                .type=${'ACTION_BUTTON_1'}
                                .text=${'Close Outbound Queue Item'}
                                .disabled=${shouldDisableActionItemButtons(state)}
                                @joButtonClick=${() => {
            this.closeOutboundQueueItemClicked();
        }}
                            ></jo-button>
                        </div>

                        <div
                            ?hidden=${this.shouldSaveButtonDisappear()}
                            class="jo-call-screen-collection--send-to-callbacks-button-container"
                        >
                            <jo-button
                                .type=${'ACTION_BUTTON_1'}
                                .text=${'Save'}
                                .disabled=${shouldDisableActionItemButtons(state)}
                                @joButtonClick=${() => {
            (0, utilities_1.raiseCustomEvent)(this, 'saveActionItemButtonClicked');
            this.save();
        }}
                            ></jo-button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    getFlexClassForNotesAndChatContainer() {
        if (this.store.callScreenMode === 'CHAT') {
            return 'jo-call-screen-collection--flex-ChatMode';
        }
        return 'jo-call-screen-collection--flex-RegMode';
    }
}
(0, define_custom_element_1.defineCustomElement)('jo-call-screen-collection', JOCallScreenCollection);
function getCompanyCalendarConnections(companyForCollection) {
    return companyForCollection !== 'NOT_SET'
        ? companyForCollection.calendar_connections ?? []
        : [];
}
function getCompanyCalendar(companyForCollection) {
    return companyForCollection !== 'NOT_SET'
        ? companyForCollection.calendar ?? 'NOT_SET'
        : 'NOT_SET';
}
function getAlert(state) {
    if (state.companyForCollection !== 'NOT_SET') {
        return (0, lit_html_1.html) `
            <div>
                ALERT (expires
                ${new Date(state.companyForCollection.alerts_expiration_date).toLocaleDateString()})
            </div>
            <br />
            <div>${state.companyForCollection.alerts}</div>
        `;
    }
}
function shouldDisableActionItemButtons(state) {
    if (state.saveActionItemInitiated === true)
        return true;
    if (state.redirectingIncomingCallbackToOutgoing === true) {
        return true;
    }
    if (state.callScreenMode === 'ACTION_ITEM') {
        return false;
    }
    // this means the call screen was refreshed during a call
    if (state.settingUpInitialCallScreenInfoHasInitiated && state.incomingCallType === 'NOT_SET') {
        return false;
    }
    if ((0, utilities_1.shouldDisableCallActionButtonsDuringCall)(state.callScreenMode, state.transferState, state.incomingCallType, state.incomingTransferCompleted) === true) {
        return true;
    }
    if (state.callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM') {
        return state.transferState === 'STARTED' || state.callAnswered === false;
    }
    if (state.callScreenMode === 'OUTGOING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'OUTGOING_EXISTING_ACTION_ITEM') {
        return state.transferState === 'STARTED';
    }
    if (state.callScreenMode === 'NOT_SET') {
        return true;
    }
    return false;
}
function shouldHideEndOfScript(state) {
    if (state.companyForCollection === 'NOT_SET') {
        return true;
    }
    return state.companyForCollection.end_of_script_text.trim() === '';
}
function getActionItemTitle(state) {
    if (state.callScreenMode === 'CHAT') {
        return state.actionItemTitles.title;
    }
    if (state.actionItem === 'NOT_SET' || !state.actionItem.title) {
        return '';
    }
    return state.actionItem.title.split(' -- ')[0];
}
function getActionItemSubtitle(state) {
    if (state.callScreenMode === 'CHAT') {
        return state.actionItemTitles.subtitle;
    }
    if (state.actionItem === 'NOT_SET') {
        return '';
    }
    // TODO this is just here for legacy reasons...once the rails app is deleted, just use the title and subtitle fields
    const legacySubtitle = state.actionItem.title?.split(' -- ')[1];
    if (legacySubtitle !== undefined) {
        return legacySubtitle;
    }
    return state.actionItem.subtitle;
}
function getSortedServices(services) {
    if (!services)
        return services;
    const sortedServices = [...services].sort((serviceA, serviceB) => {
        return serviceA.display_position - serviceB.display_position;
    });
    return sortedServices;
}
function getCustomFieldResponses(state) {
    return state.customFieldResponsesInputValues.some(c => c.response !== '')
        ? state.customFieldResponsesInputValues.map(c => ({
            ...c,
            custom_field: c.customField,
        }))
        : state.previousCustomFieldResponses;
}
function getServiceLineItemResponses(state) {
    if (state.pricingInputValues !== 'NOT_SET') {
        return state.pricingInputValues.serviceLineItemResponsesInputValues;
    }
    return state.previousLineItemResponses;
}
